import $ from 'jquery';

$(() => {
	const recalculate = () => {
		const headerHeight = parseInt($('.main-header').height(), 10);
		const windowWidth = $(window).width();
		const $header = $('.sticky-header');
		const $content = $('#page-content');

		$('.do-sticky').toggleClass('sticky-header', $(document).scrollTop() > 40);

		$('.dashboard').css('top', headerHeight);

		if (windowWidth <= 992) {
			$content.css('margin-top', $header.outerHeight());

			return;
		}

		if ($(document).scrollTop() >= 100) {
			if (!$('.header-shrink').length) {
				$header.addClass('header-shrink');
			}

			$content.css('margin-top', $header.outerHeight());

			return;
		}

		$content.css('margin-top', $header.outerHeight());

		$header.removeClass('header-shrink');
	};

	recalculate();

	$(window).on('scroll resize', () => recalculate());

	$('.dashboard-nav').css('min-height', $(window).height());

	$('.dropdown-menu a.dropdown-toggle').on('click', event => {
		let $dropdown = $(event.currentTarget);

		if (!$dropdown.next().hasClass('show')) {
			$dropdown.parents('.dropdown-menu').first().find('.show').removeClass('show');
		}

		$dropdown.next('.dropdown-menu').toggleClass('show');

		$dropdown
			.parents('li.nav-item.dropdown.show')
			.on('hidden.bs.dropdown', () => $('.dropdown-submenu .show').removeClass('show'));

		return false;
	});
});



// WEBPACK FOOTER //
// ./resources/js/app/header.js